import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-modal w-maxC" }
const _hoisted_2 = { class: "row w-full" }
const _hoisted_3 = { class: "contactInputGrid mtop-15" }
const _hoisted_4 = { style: {"grid-column":"left","justify-self":"end","margin-top":"0.45rem"} }
const _hoisted_5 = { class: "row mtop-04" }

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import relationshipapi from '@/api/relationshipapi';


export default /*@__PURE__*/_defineComponent({
  __name: 'cmcmModify',
  props: {
  cmcm: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const { t } = useI18n();

const props = __props

const isCmcmActive = ref(props.cmcm.isCmcmActive);
const currCmcm = ref(props.cmcm);

async function updateIsCmcmActive() {
  const relationshipId = props.cmcm.relationshipId;
  const newIsCmcmActive = !isCmcmActive.value;
  //Update front
  isCmcmActive.value = newIsCmcmActive;
  currCmcm.value.isCmcmActive = newIsCmcmActive;
  //Update back
  await relationshipapi.updateIsCmcmActive(relationshipId, newIsCmcmActive);
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_switchGroup = _resolveComponent("switchGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.cmcmModify.title'),
          styles: "font-l"
        }, null, 8, ["txt"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.cmcmModify.useCmcm')
        }, null, 8, ["txt"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_switchGroup, {
          active: isCmcmActive.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updateIsCmcmActive()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              icon: "check",
              class: _normalizeClass(isCmcmActive.value ? 'img-white' : '')
            }, null, 8, ["class"])
          ]),
          _: 1
        }, 8, ["active"])
      ])
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mtop-04" }, null, -1))
  ]))
}
}

})